import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, StudyPlanTargets, Transitions } from "../types"
import { getServiceErrorMessage } from "../helpers"
import { setSPV2RedirectUrl } from "../studyPlanV2/actions"
import { BASE_STUDY_PLAN_V2_ADMIN_MANAGE_PATH } from "../studyPlanV2/constants"

export const restoreToRecommendedPlanTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    id: "restoreToRecommendedPlan",
    src: "restoreToRecommendedPlan",
    onDone: [
      {
        target: "#StudyPlan.teacher_view",
        cond: ctx => ctx.selfRefScope.scope === "TEACHER",
        actions: assign<Context, DoneInvokeEvent<any>>((_ctx, _evt) => ({
          recommendedStudyPlan: null
        }))
      },
      {
        target: "#StudyPlan.get_current_plan",
        actions: assign<Context, DoneInvokeEvent<any>>((ctx, _evt) => ({
          recommendedStudyPlan: null
        })),
        cond: ctx => !ctx.isStudyPlanV2Enabled
      },
      {
        target: `${BASE_STUDY_PLAN_V2_ADMIN_MANAGE_PATH}.loading`,
        actions: assign<Context>((ctx, evt) => ({
          recommendedStudyPlan: null,
          ...setSPV2RedirectUrl(
            ctx,
            evt,
            null,
            StudyPlanTargets.ManageStudyPlans
          )
        })),
        cond: ctx => ctx.isStudyPlanV2Enabled
      }
    ],
    onError: {
      target: "#StudyPlan.review_plan",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("restoreRecommendedPlan", {
            messageData: ["restore recommended study plan"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
